import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupBy',
  standalone: true,
})
export class GroupByPipe<T extends Record<string, unknown>> implements PipeTransform {
  transform(value: T[] | null, groupBy: string): { key: string; value: T[] }[] {
    if (!value) {
      return [];
    }

    const reduce = value.reduce((acc: Record<string, T[]>, cur: T) => {
      acc[cur[groupBy] as string] = [...(acc[cur[groupBy] as string] || []), cur];

      return acc;
    }, {});

    return Object.keys(reduce)
      .map(key => ({ key, value: reduce[key] }))
      .sort((a, b) => a.key.localeCompare(b.key));
  }
}
